'use client'
import Button from '../Button/Button';
import RandomImage from '../RandomImages/RandomImages';
import styles from './BannerTopo.module.css'
import classNames from 'classnames';
import { useRouter } from 'next/navigation';
import Link from 'next/link';

const BannerTopo = () =>{
    const navigate = useRouter();

    return(
        <>
        <div id="conteudoTopo"></div> 
    <section className={styles.bannerTopo} aria-labelledby="titulo-banner-topo">
        <div className={styles.dpFlex}>
            <div className={styles.containerTxTBanner}>
                <h1 id="titulo-banner-topo" tabIndex={0} className={styles.heading}>
                    <span className={styles.highlight}>Biblioteca Virtual</span> para universidades e empresas!
                </h1>
                <p tabIndex={0}>A Biblioteca Virtual Pearson é uma iniciativa pioneira de acervo virtual que reúne títulos de mais de 80 editoras parceiras, com acesso ilimitado e multiusuário</p>
                <div className={styles.containerBtns}>                    
                    <Link href="/QuemSomos" className={classNames(styles.btn, styles.blue)} aria-label='Conheça a Biblioteca Virtual - Acessar Página Quem Somos'>
                         Conheça a Biblioteca Virtual                        
                    </Link>

                    <Link href="/EuQuero" className={classNames(styles.btn, styles.blueLight)} aria-label="Eu Quero - Ir para página Experimente">
                        Experimente
                    </Link>
                </div>
            </div>

            <div className={styles.imgLoop}>
                <RandomImage/>
            </div>
        </div>
    </section>
    </>
    );
}

export default BannerTopo